import { ChangeEvent, useState } from "react";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useUserInfor } from "../../../../Context/User";
import { AtualizarHistoricosController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { HistoricoInterface } from "../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import Editor from "../../Forms/Editor";
import { Switch } from "../../Forms/Switch";

interface ModalCadastrarPropsInterface {
    setShow: (show: boolean) => void;
    historico: HistoricoInterface;
}

export default function AtualizarHistorico(
    props: ModalCadastrarPropsInterface
) {
    const { Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const userId = useUserInfor().UserInfor.ID_USUARIO;

    const [uploading, setUploading] = useState(false);
    const [historicoHTML, setHistoricoHTML] = useState(
        props.historico.DS_HISTORICO
    );
    const [Selecionado, setSelecionado] = useState(false);

    const onSubmit = () => {
        if (userId && Atendimento && historicoHTML) {
            AtualizarHistoricosController({
                ...props.historico,
                DS_HISTORICO: historicoHTML,
                FL_CLIENTE_VISUALIZA_HISTORICO: Selecionado,
            }).then((res) => {
                props.setShow(false);
                setHistoricoHTML("");
                ReloadHistorico();
            });
        }
    };
    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setSelecionado(e.target.checked);
    }

    return (
        <>
            <div className="text-center mb-lg-5">
                <h2 className="font-weight-bold">Atualização de Histórico</h2>
            </div>
            {uploading && (
                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                    Fazendo upload de imagem{" "}
                    <Spinner size="sm" color="primary" />
                </div>
            )}
            <Editor
                onChange={(value) => {
                    setHistoricoHTML(value);
                }}
                idCaso={Atendimento?.ID_CASO}
                onImageUploadStart={() => setUploading(true)}
                onImageUploadEnd={() => setUploading(false)}
                value={historicoHTML}
                placeholder="Descrição"
            />
            <Switch
                label="Cliente visualiza"
                type="checkbox"
                color="success"
                swicthSize="sm"
                checked={Selecionado}
                onChange={handleChange}
            />
            <div className="d-flex flex-wrap justify-content-center align-items-center lg-5 mt-1">
                <button
                    type="submit"
                    disabled={!historicoHTML?.length || uploading}
                    className="btn btn-capys font-weight-bold"
                    onClick={onSubmit}
                >
                    Atualizar
                </button>
            </div>
        </>
    );
}
